// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { eon as _eon } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the eon chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7332
 * Chain Name: Horizen EON
 * Default Block Explorer: https://eon-explorer.horizenlabs.io
 * Default RPC URL: https://eon-rpc.horizenlabs.io/ethv1
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { eon } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: eon,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const eon = createCommon({
	..._eon,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
